import defaultImgUrl from '/imgs/text_generated_image/auto.jpg';
import cartoonImgUrl from '/imgs/text_generated_image/3d_cartoon.jpg';
import flatIllustrationImgUrl from '/imgs/text_generated_image/flat_illustration.jpg';
import animeImgUrl from '/imgs/text_generated_image/anime.jpg';
import waterColorImgUrl from '/imgs/text_generated_image/watercolor.jpg';
import sketchImgUrl from '/imgs/text_generated_image/sketch.jpg';
import oilPaintingImgUrl from '/imgs/text_generated_image/oil_painting.jpg';
import chinesePaintingImgUrl from '/imgs/text_generated_image/chinese_painting.jpg';

import largeDefaultImgUrl from '/imgs/text_generated_image/auto_large.jpg';
import largeCartoonImgUrl from '/imgs/text_generated_image/3d_cartoon_large.jpg';
import largeFlatIllustrationImgUrl from '/imgs/text_generated_image/flat_illustration_large.jpg';
import largeAnimeImgUrl from '/imgs/text_generated_image/anime_large.jpg';
import largeWaterColorImgUrl from '/imgs/text_generated_image/watercolor_large.jpg';
import largeSketchImgUrl from '/imgs/text_generated_image/sketch_large.jpg';
import largeOilPaintingImgUrl from '/imgs/text_generated_image/oil_painting_large.jpg';
import largeChinesePaintingImgUrl from '/imgs/text_generated_image/chinese_painting_large.jpg';

export enum ImgStyle {
    AUTO = '<auto>',
    '3D_CARTOON' = '<3d cartoon>',
    FLAT_ILLUSTRATION = '<flat illustration>',
    ANIME = '<anime>',
    WATERCOLOR = '<watercolor>',
    SKETCH = '<sketch>',
    OIL_PAINTING = '<oil painting>',
    CHINESE_PAINTING = '<chinese painting>'
}

export const imgStyleMap = {
    [ImgStyle.AUTO]: '默认',
    [ImgStyle["3D_CARTOON"]]: '3D卡通',
    [ImgStyle.FLAT_ILLUSTRATION]: '扁平插画',
    [ImgStyle.ANIME]: '动画',
    [ImgStyle.WATERCOLOR]: '水彩',
    [ImgStyle.SKETCH]: '素描',
    [ImgStyle.OIL_PAINTING]: '油画',
    [ImgStyle.CHINESE_PAINTING]: '中国画'
}

export const imgStyleReverseMap = Object.keys(imgStyleMap).reduce((pre, cur) => {
    pre[imgStyleMap[cur]] = cur;
    return pre;
}, {});

export const enum SizeType {
    '1:1' = '1024*1024',
    '16:9' = '1280*720',
    '9:16' = '720*1280'
}

export const imgStyleOptions = [
    {
        url: defaultImgUrl,
        largeImgUrl: largeDefaultImgUrl,
        styleName: imgStyleMap[ImgStyle.AUTO],
        style: ImgStyle.AUTO,
        selected: true
    },
    {
        url: cartoonImgUrl,
        largeImgUrl: largeCartoonImgUrl,
        styleName: imgStyleMap[ImgStyle['3D_CARTOON']],
        style: ImgStyle['3D_CARTOON'],
        selected: false
    },
    {
        url: flatIllustrationImgUrl,
        largeImgUrl: largeFlatIllustrationImgUrl,
        styleName: imgStyleMap[ImgStyle.FLAT_ILLUSTRATION],
        style: ImgStyle.FLAT_ILLUSTRATION,
        selected: false
    },
    {
        url: animeImgUrl,
        largeImgUrl: largeAnimeImgUrl,
        styleName: imgStyleMap[ImgStyle.ANIME],
        style: ImgStyle.ANIME,
        selected: false
    },
    {
        url: waterColorImgUrl,
        largeImgUrl: largeWaterColorImgUrl,
        styleName: imgStyleMap[ImgStyle.WATERCOLOR],
        style: ImgStyle.WATERCOLOR,
        selected: false
    },
    {
        url: sketchImgUrl,
        largeImgUrl: largeSketchImgUrl,
        styleName: imgStyleMap[ImgStyle.SKETCH],
        style: ImgStyle.SKETCH,
        selected: false
    },
    {
        url: oilPaintingImgUrl,
        largeImgUrl: largeOilPaintingImgUrl,
        styleName: imgStyleMap[ImgStyle.OIL_PAINTING],
        style: ImgStyle.OIL_PAINTING,
        selected: false
    },
    {
        url: chinesePaintingImgUrl,
        largeImgUrl: largeChinesePaintingImgUrl,
        styleName: imgStyleMap[ImgStyle.CHINESE_PAINTING],
        style: ImgStyle.CHINESE_PAINTING,
        selected: false
    }
]